// This file is auto-generated by packages/dev/scripts/generate-module-registry.js
// Do not edit manually - it will be overwritten

import type { ModuleRegistration } from '@korvo/core/types/module-boundaries';

export const moduleDescriptorPartials: Record<string, Partial<Omit<ModuleRegistration, 'id'>>> = {};
